// extracted by mini-css-extract-plugin
export default {"analiticsField":"analitics_analiticsField__78IbS","inputContainer":"analitics_inputContainer__GfOMP","timerContainer":"analitics_timerContainer__BiH9h"};